import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputTextComponent),
      multi: true
    }
  ]
})
export class InputTextComponent implements OnInit, OnChanges, ControlValueAccessor {
  @Input() disabled = false;
  @Input() width: string;
  @Input() label: string;
  @Input() placeholder = '';
  @Input() icon = '';
  @Input() autofocus = false;
  @Input() type = 'text';
  @Output() iconClick = new EventEmitter<string>();

  @ViewChild('text') input: ElementRef;

  rootClass: string;
  classMap: any;
  formControl: FormControl;

  constructor(private elementRef: ElementRef) {}

  onChange: any = () => {};
  onTouched: any = () => {};

  updateClassMap() {
    this.classMap = {
      [`${this.rootClass}`]: true,
      [`${this.rootClass}--disabled`]: this.disabled,
      [`${this.rootClass}--available`]: this.width
    };
  }

  writeValue(value: any): void {
    this.formControl.setValue(value);
  }

  registerOnChange(fn: any): void {
    this.formControl.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.formControl.disable();
    } else {
      this.formControl.enable();
    }
  }

  onKeyPress(event: any) {
    if (event.which === 13) {
      this.iconClick.emit(this.formControl.value);
    }

    if (event.which === 91 && event.ctrlKey) {
      this.input.nativeElement.select();
    }
  }

  ngOnChanges() {
    this.updateClassMap();
  }

  ngOnInit() {
    this.rootClass = this.elementRef.nativeElement.tagName.toLowerCase();
    this.updateClassMap();

    this.formControl = new FormControl();
  }
}
